var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTanker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4,7.3H4.7V6.7h0.2V6.1H3.5v0.7h0.2v0.5h-2c0,0-0.7,0.4-0.7,3.4s0.9,3.2,0.9,3.2h13.4c0,0,0.7-0.7,0.8-3.4 c0.1-2.7-0.9-3.2-0.9-3.2h-2.1V6.7h0.2V6.1h-2.2v0.6h0.2V7.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.9,8.8c0,0.8,0,1.7,0,2.5c0.8,0,1.6,0,2.4,0c-0.2-0.8-0.5-1.7-0.7-2.5C19,8.8,18.5,8.8,17.9,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.6,15.5c-0.3,0-0.5,0.2-0.6,0.5c0,0,0,0.1,0,0.1c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.4,0.1 c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0,0,0-0.1,0-0.1C19.1,15.7,18.9,15.5,18.6,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4,15.7c-0.1-0.1-0.3-0.3-0.5-0.3c-0.2,0-0.4,0.1-0.5,0.3C3,15.8,3,15.9,3,16C3,16,3,16,3,16 c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0,0,0-0.1,0-0.1 C4.1,15.9,4.1,15.8,4,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21,13.9c0,0.3,0,0.6,0,0.9c0.5,0,1,0,1.5,0c0-0.3,0-0.6,0-0.9C21.9,13.9,21.5,13.9,21,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.6,14.2c-1.1,0-1.9,0.8-1.9,1.9c0,1.1,0.8,1.9,1.9,1.9c1.1,0,1.9-0.8,1.9-1.9 C20.5,15,19.7,14.2,18.6,14.2z M19,16.5c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1C18.1,16.4,18,16.2,18,16c0,0,0-0.1,0-0.1 c0-0.3,0.3-0.5,0.6-0.5c0.3,0,0.5,0.2,0.6,0.5c0,0,0,0.1,0,0.1C19.2,16.2,19.1,16.3,19,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3.6,14.2L3.6,14.2c-1,0-1.7,0.7-1.9,1.6c0,0.1,0,0.2,0,0.3c0,1.1,0.8,1.9,1.9,1.9s1.9-0.8,1.9-1.9 c0-0.1,0-0.2,0-0.3C5.3,14.8,4.5,14.2,3.6,14.2z M3.9,16.5c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1C3,16.4,3,16.2,3,16 C3,16,3,16,3,16c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.3-0.3,0.5-0.3c0.2,0,0.4,0.1,0.5,0.3c0,0,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1 C4.1,16.2,4.1,16.3,3.9,16.5z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9,14.2H1.3v1.6h0.3l0,0C1.7,15,2.2,14.4,2.9,14.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,14.7c0-0.9,0-1.7,0-2.6c-0.3-0.1-0.6-0.3-0.8-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c0,0,0,0-0.1,0 c-0.4-0.2-0.4-0.7-0.5-1.1C20.4,9.6,20.1,9,20,8.4c-0.1-0.4-0.2-0.8-0.1-1.2c-1.1,0-2.3,0-3.4,0l0,0l0,0l0,0v1.4l0,0 c0,1.8,0,3.7,0,5.6H4.2c0.7,0.2,1.2,0.8,1.3,1.6l0,0h10.9c0.3-0.9,1-1.8,2-1.8c1.1-0.2,2.1,0.7,2.4,1.8c0.7,0,1.4,0,2.2,0 c0-0.3,0-0.6,0-0.9C22.8,14.8,22.7,14.7,22.6,14.7z M17.9,11.3c0-0.8,0-1.7,0-2.5c0.6,0,1.1,0,1.7,0c0.2,0.8,0.5,1.7,0.7,2.5 C19.5,11.3,18.7,11.3,17.9,11.3z M22.5,14.8c-0.5,0-1,0-1.5,0c0-0.3,0-0.6,0-0.9c0.5,0,1,0,1.5,0C22.5,14.2,22.5,14.5,22.5,14.8z "
  }))))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "4.7,7.3 4.7,6.7 4.9,6.7 4.9,6.1 3.5,6.1 3.5,6.8 3.7,6.8 3.7,7.3 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "11.1,6.7 11.1,6.1 13.4,6.1 13.4,6.7 13.2,6.7 13.2,7.3 11.4,7.3 11.4,6.7 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTanker);
export default __webpack_public_path__ + "static/media/tanker.9b8620940c3c93a6dca2baa44416c617.svg";
export { ForwardRef as ReactComponent };